module.exports = __webpack_public_path__ + "static/media/collection_page_2028_btn.421c7bcf.png";